import React from "react";
import Images from "../../Component/Simage";

function DeveloperFriently() {
  return (
    <div className="container ai-container">
      <div className="developer_friently">
        <p className="title fw-700 mb-0 text-center">
          Developer Friendly
        </p>
        <p className="des fw-300 text-center mb-0">
          Serve your data with a minimal snippet
        </p>
        <div className="img_sec">
          <img src={Images.codeWritter} className="img-fluid img_src" />
        </div>
      </div>
    </div>
  );
}

export default DeveloperFriently;
